export default "__VITE_ASSET__q_kVjJm6__"